import { BoxStyleProps } from "@twilio-paste/core/box";

export const outerContainerStyles: BoxStyleProps = {
    position: "fixed",
    bottom: "space50",
    right: "space60",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end"
};

export const innerContainerStyles: BoxStyleProps = {
    boxShadow: "shadow",
    display: "flex",
    flexDirection: "column",
    width: "320px",
    height: "590px",
    marginBottom: "space50",
    borderRadius: "borderRadius30",
    backgroundColor: "colorBackgroundBody"
};

export const outerContainerStylesMobile: BoxStyleProps = {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    minHeight: "100%"
};

export const innerContainerStylesMobile: BoxStyleProps = {
    boxShadow: "shadow",
    display: "flex",
    flexDirection: "column",
    width: "100vw",
    minHeight: "calc(var(--vh, 1vh) * 100 - 0.5px)",
    borderRadius: "borderRadius30",
    backgroundColor: "colorBackgroundBody"
};
